import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type SurveyJsQuiz = {
   quizid: number;
   quiz_revisionid: number;
   created_date: number;
   author: number;
   deleted: boolean;
};

export type QuizRevision = {
   quiz_revisionid: number;
   modified_by: number;
   title: string;
   description: string;
   passing_score: number;
   deleted: boolean;
   date: number;
   enabled: boolean;
   quizid: number;
};

export type QuizQuestion = {
   questionid: number;
   quizid: number;
   quiz_revisionid: number;
   name: string;
   type: string;
   question_json: string;
   answer_json: string;
   created_date: number;
   page: number;
   page_order: number;
};

export type CreateQuizResponse = {
   quiz: SurveyJsQuiz;
   quiz_revision: QuizRevision | null;
   questions: Array<QuizQuestion>;
};

export async function createQuiz(
   quizJson: string,
   { ...common }: CommonRequestOptions
): Promise<CreateQuizResponse> {
   return makeRequest('post', '/quizzes/import', {
      ...common,
      body: {
         quizJson,
      },
   });
}
